import { useRouter } from "next/router";

import useUser from "@/users/useUser";

const useCanViewExperimentManager = () => {
  const {
    query: { showExperimentManager },
  } = useRouter();
  const { data: user } = useUser();
  return Boolean(
    user?.is_staff ||
      user?.features?.is_demo_user === "on" ||
      showExperimentManager === "1",
  );
};

export default useCanViewExperimentManager;
